import { render, staticRenderFns } from "./SaleRatioStatisticsList.vue?vue&type=template&id=59b0f2ff&scoped=true"
import script from "./SaleRatioStatisticsList.vue?vue&type=script&lang=js"
export * from "./SaleRatioStatisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b0f2ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b0f2ff')) {
      api.createRecord('59b0f2ff', component.options)
    } else {
      api.reload('59b0f2ff', component.options)
    }
    module.hot.accept("./SaleRatioStatisticsList.vue?vue&type=template&id=59b0f2ff&scoped=true", function () {
      api.rerender('59b0f2ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/sale-ratio-statistics/SaleRatioStatisticsList.vue"
export default component.exports